import { Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getBusinessSites } from '../../api';
import BaseMap from '../Map';
import Sites from './Sites';
import PropTypes from 'prop-types';
import NPaper from '../NPaper';


function Home(props) {
  const { business } = props;
  const history = useHistory();

  const [sites, setSites] = useState(null);

  useEffect(() => {
    getBusinessSites(business.id, {
      latestImage: true,
      device: true
    })
      .then(sites => setSites(sites))
      .catch(err => console.log(err));
  }, [business]);


  if (!sites) return null;


  return (
    <>
      <Typography variant='h5'>Sites</Typography>
      <Sites
        business={business}
        sites={sites} 
      />

      <br />

      <Typography variant='h5'>Map</Typography>
      <NPaper>
        <BaseMap
          locations={sites.map(site => ({
            id: site.id,
            lat: site.device?.latitude,
            lng: site.device?.longitude,
            onClick: () => history.push(`/business/${business.url || business.id}/site/${site.url || site.id}`)
          }))}
        />
      </NPaper>
    </>
  );
}

Home.propTypes = {
  business: PropTypes.object
}


export default Home;
